/**
 * Whether Google sign-in cannot work here: an iOS app's embedded web view,
 * such as the monday.com iOS app rendering our item view.
 *
 * signInWithPopup cannot open a popup there — iOS opens it as a separate tab
 * with its own storage and no window.opener, so Firebase's handler fails with
 * "missing initial state" and the result could never reach the view anyway.
 * signInWithRedirect does not help either: Google refuses to sign in inside
 * embedded web views (disallowed_useragent). Email/password is the only
 * sign-in that completes in place.
 *
 * Detection: WKWebView's user agent carries the iOS device tokens but, unlike
 * Safari and the third-party iOS browsers (CriOS, FxiOS, EdgiOS), no
 * "Safari/" token. iPadOS reports a Mac user agent by default, so a touch
 * "Macintosh" counts as iOS too.
 */
export function isEmbeddedIOSWebView(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isIOS =
    /iPhone|iPad|iPod/.test(ua) ||
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  return isIOS && /AppleWebKit/.test(ua) && !/Safari\//.test(ua);
}
